import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const ConciergePackages = lazy(() => import("@/pages/ConciergePackages"));

export const Route = createFileRoute("/concierge/packages")({
  component: ConciergePackages,
});
